import { Spacer, SpacerProps } from '@chakra-ui/react';
import React from 'react';

export type QSpacerProps = SpacerProps;

export const QSpacer: React.FC<QSpacerProps> = (props) => {
  return <Spacer {...props} />;
};
